import styled from 'styled-components';

export default styled.div`
  background-color: white;
  border-bottom-right-radius: 0.75rem;
  padding: 2rem;
`;
